import { useContext } from 'react'

import { AlertContext } from '../AlertContext'

export const useRemoveAlert = () => {
  const context = useContext(AlertContext)

  if (!context) {
    throw new Error('useRemoveAlert must be used within AlertProvider')
  }

  return context.removeAlert
}
